import { render, staticRenderFns } from "./eat_livraison.vue?vue&type=template&id=25c0bbcc&scoped=true&"
import script from "./eat_livraison.vue?vue&type=script&lang=js&"
export * from "./eat_livraison.vue?vue&type=script&lang=js&"
import style0 from "./eat_livraison.vue?vue&type=style&index=0&id=25c0bbcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c0bbcc",
  null
  
)

export default component.exports